export default "__VITE_ASSET__ykG8ZKdb__"